import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoFileSearch = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>FileSearch</title>
    <path
      d="M26.856 12.75v14.526a2.429 2.429 0 0 1-2.429 2.428H9.57a2.429 2.429 0 0 1-2.43-2.428V6.703a2.429 2.429 0 0 1 2.43-2.429h8.475c.621 0 1.22.239 1.67.666l6.383 6.046c.484.46.758 1.097.758 1.764Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M26.712 12.417h-4.571a3.429 3.429 0 0 1-3.43-3.429V4.417"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <circle cx={16.427} cy={19.274} r={3.571} stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
    <path d="m19.284 22.132 2.856 2.856" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);
export default SvgIcoFileSearch;
